<template>
    <div class="home-container">
       <!-- 新增的顶部栏 -->
       <div class="header-bar">
        <div class="header-title">
          <div class="weather-info">
            <template v-if="weatherLoading">
              <el-icon class="is-loading"><Loading /></el-icon>
              加载天气中...
            </template>
            <template v-else-if="weatherError">
              天气数据加载失败
            </template>
            <template v-else>
              <span class="weather-item">
                <img src="http://lzy.zhizhizuimei.top/d02d3caebad34db299348f1310da570d.jpg" class="weather-icon" />
                无锡: {{ currentWeather.wuxi.temp }}°C {{ currentWeather.wuxi.text }}
              </span>
              | 
              <span class="weather-item">
                <img src="http://lzy.zhizhizuimei.top/4a92946847db4e4a8e665f8f1d9aba3c.jpg" class="weather-icon" />
                南京: {{ currentWeather.nanjing.temp }}°C {{ currentWeather.nanjing.text }}
              </span>
            </template>
          </div>
          <div class="center-title">永远都像初次见你那样，使我心荡漾</div>
          <div class="days-counter">和栀栀在一起已经{{ daysTogether }}天</div>
        </div>
        <div class="header-actions">
          <el-dropdown>
            <span class="el-dropdown-link">
              <el-avatar :size="50" src="http://lzy.zhizhizuimei.top/c543033078cc3862dff5ac9dbaceab4c.JPG" />
              <span class="username">{{ username }}</span>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <!-- 顶部导航按钮 -->
      <div class="nav-buttons">
        <el-button 
          type="primary" 
          plain
          @click="navigateTo('/home')"
          class="home-button"
        >
          点击我回到主页哟
        </el-button>
  
      </div>
  
      <!-- 主内容区 -->
      <div class="main-content">
        <!-- 搜索框 - 调整大小和位置 -->
        <div class="search-box-container">
          <div class="search-box">
            <el-input
              v-model="searchContent"
              placeholder="请输入特殊时期时间进行搜索"
              clearable
              @clear="search"
              @keyup.enter="search"
              class="search-input"
            >
              <template #append>
                <el-button :icon="Search" @click="search" class="search-button" />
              </template>
            </el-input>
          </div>
        </div>
        
          
         
        <!-- 操作按钮 -->
        <div class="action-buttons">
          <el-button type="primary" :icon="Plus" @click="addItem">添加</el-button>
          <el-button type="warning" :icon="Edit" @click="editItem">修改</el-button>
          <el-button type="danger" :icon="Delete" @click="deleteItem">删除</el-button>
        </div>
  
        <!-- 表格 -->
        <el-table 
          :data="items" 
          stripe 
          style="width: 100%" 
          @row-click="handleRowClick"  
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="55" />
          <el-table-column type="index" label="序号" width="80" >
            <template #default="{ $index}">
        <div class="table-content name-content">
          {{ $index + 1 + (currentPage - 1) * pageSize }}
        </div>
      </template>
    </el-table-column>
          <el-table-column prop="content" label="特殊时期时间" >
          <template #default="{ row }">
        <div class="table-content name-content">
          {{ row.content }}
        </div>
      </template>
    </el-table-column>
          <el-table-column prop="last" label="距离上次多久" >
            <template #default="{ row }">
        <div class="table-content wine-content">
          {{ row.last}}
        </div>
      </template>
    </el-table-column>  
    <el-table-column prop="important" label="注意事项"  >
            <template #default="{ row }">
        <div class="table-content wine-content">
          {{ row.important}}
        </div>
      </template>
    </el-table-column> 
        </el-table>
  
  
        <!-- 分页 -->
        <!-- 在template中找到pagination部分，替换为以下代码 -->
  <!-- 替换原有的分页部分 -->
  <div class="pagination-container">
    <div class="custom-pagination">
      <el-button 
        class="page-first" 
        :disabled="currentPage === 1 || total === 0"
        @click="goToPage(1)"
      >
        <el-icon><ArrowLeft /></el-icon> 首页
      </el-button>
      <el-button 
        class="page-prev" 
        :disabled="currentPage === 1 || total === 0"
        @click="goToPage(currentPage - 1)"
      >
        <el-icon><ArrowLeft /></el-icon>
      </el-button>
      
      <div class="page-input">
        <span>第</span>
        <el-input
          v-model="inputPage"
          placeholder="页码"
          style="width: 60px"
          @keyup.enter="handlePageInput"
          :disabled="total === 0"
        />
        <span>页</span>
        <span class="total-pages">共 {{ totalPages }} 页</span>
      </div>
      
      <el-button 
        class="page-next" 
        :disabled="currentPage === totalPages || total === 0"
        @click="goToPage(currentPage + 1)"
      >
        <el-icon><ArrowRight /></el-icon>
      </el-button>
      <el-button 
        class="page-last" 
        :disabled="currentPage === totalPages || total === 0"
        @click="goToPage(totalPages)"
      >
        尾页 <el-icon><ArrowRight /></el-icon>
      </el-button>
    </div>
  </div>
        <!-- 添加/修改对话框 -->
        <el-dialog 
      v-model="showModal" 
      :title="form.id ? '修改任务' : '添加任务'"
      class="custom-dialog"
      width="600px"
    >
      <el-form :model="form" label-width="100px" class="custom-form">
        <el-form-item label="特殊时期时间" class="form-item">
          <el-input 
            v-model="form.content" 
            placeholder="请输入特殊时期时间" 
            class="custom-input"
            clearable
          />
        </el-form-item>
        <el-form-item label="距离上次多久" class="form-item">
          <el-input 
            v-model="form.last" 
            placeholder="请输入距离上次多久" 
            class="custom-input"
            clearable
          />
        </el-form-item>
        <el-form-item label="注意事项" class="form-item">
          <el-input 
            v-model="form.important" 
            placeholder="请输入注意事项" 
            class="custom-input"
            clearable
          />
        </el-form-item>
      </el-form>
      
      <template #footer>
        <div class="dialog-footer">
          <el-button 
            @click="cancel" 
            class="cancel-button"
          >
            取消
          </el-button>
        <el-button 
            type="primary" 
            @click="saveItem" 
            class="confirm-button"
          >
            保存
          </el-button>
        </div>
      </template>
    </el-dialog>
  
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import axios from 'axios';
  import { ElMessage,ElMessageBox } from 'element-plus';
  import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';
  
  import { computed } from 'vue';
  import { Search, Plus, Edit, Delete, Document, Download, Upload, View } from '@element-plus/icons-vue';
  
  // 添加时间格式化方法
const formatDateTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
  // 计算总页数
  const totalPages = computed(() => {
    return Math.ceil(total.value / pageSize.value) || 1; // 确保至少为1页
  });
  // 添加这些变量和方法
  const inputPage = ref(''); // 改为字符串类型
  const handlePageInput = () => {
    const page = parseInt(inputPage.value);
    if (!isNaN(page) && page >= 1 && page <= totalPages.value) {
      goToPage(page);
    } else {
      // 输入无效时重置为当前页
      inputPage.value = currentPage.value;
      ElMessage.warning(`请输入有效的页码 (1-${totalPages.value})`);
    }
  };
  
  
  
  const goToPage = (page) => {
    currentPage.value = page;
    inputPage.value = page.toString(); // 更新输入框显示
    fetchItems();
  };
  
  
  const WEATHER_API_KEY = '91d0322fa7a74b3e9cf46ec505dc3346'; // 替换为你的和风天气API Key
  const weatherLoading = ref(true);
  const weatherError = ref(false);
  const weatherApi = axios.create({
    baseURL: 'https://devapi.qweather.com/v7/weather/',
    headers: {
      'X-QW-Api-Key': WEATHER_API_KEY
    }
  });
  const currentWeather = ref({
    wuxi: { icon: '100', temp: '--', text: '--' }, // 默认值
    nanjing: { icon: '100', temp: '--', text: '--' } // 默认值
  });
  const weatherIconMap = {
    '100': '100', // 晴 (日间)
    '150': '150', // 晴 (夜间)
    '101': '101', // 多云
    '102': '102', // 少云
    '103': '103', // 晴间多云
    '104': '104', // 阴
    '300': '300', // 雨
    '301': '301', // 阵雨
    '302': '302', // 雷阵雨
    '400': '400', // 雪
    '401': '401', // 阵雪
    '402': '402', // 小雪
    '403': '403', // 中雪
    '404': '404', // 大雪
    '500': '500', // 雾
    '502': '502', // 霾
    '503': '503', // 扬沙
    '504': '504', // 浮尘
    '507': '507', // 沙尘暴
    '999': '999'  // 未知
  };
  const getWeatherIcon = (iconCode) => {
    // 检查iconCode是否存在映射中，不存在则使用默认图标
    const iconName = weatherIconMap[iconCode] || '999';
    
    // 使用多个CDN源确保可用性
    const cdnUrls = [
      `https://a.hecdn.net/img/common/icon/202106d/${iconName}.png`,
      `https://www.qweather.com/img/common/icon/202106d/${iconName}.png`,
      `https://file.qweather.com/img/common/icon/202106d/${iconName}.png`
    ];
    
    return cdnUrls[0]; // 使用第一个URL，如果失败可以添加备用逻辑
  };
  // 获取实时天气数据
  const fetchCurrentWeather = async (location, city) => {
    try {
      const response = await weatherApi.get(`now?location=${location}`);
      if (response.data.code === '200') {
        currentWeather.value[city] = {
          temp: response.data.now.temp,
          text: response.data.now.text,
          icon: response.data.now.icon,
          windDir: response.data.now.windDir,
          windScale: response.data.now.windScale,
          humidity: response.data.now.humidity
        };
      } else {
        throw new Error(response.data.message || '获取天气数据失败');
      }
    } catch (error) {
      console.error(`获取${city}实时天气失败:`, error);
      throw error;
    }
  };
  const WEATHER_CACHE_KEY = 'weather_cache';
  const CACHE_EXPIRY = 2 * 60 * 1000; // 2分钟缓存时间
  // 获取天气数据
  const fetchWeather = async () => {
    const cachedData = localStorage.getItem(WEATHER_CACHE_KEY);
    if (cachedData) {
      const { data, timestamp } = JSON.parse(cachedData);
      if (Date.now() - timestamp < CACHE_EXPIRY) {
        currentWeather.value = data;
        weatherLoading.value = false;
        return; // 使用缓存数据，不调用API
      }
    }
  
    weatherLoading.value = true;
    weatherError.value = false;
    
    try {
      // 并行获取无锡和南京的天气数据
      await Promise.all([
        fetchCurrentWeather('101190201', 'wuxi'),
        fetchCurrentWeather('101190101', 'nanjing')
      ]);
      localStorage.setItem(WEATHER_CACHE_KEY, JSON.stringify({
        data: currentWeather.value,
        timestamp: Date.now()
      }));
    } catch (error) {
  
      weatherError.value = true;
      if (cachedData) {
        const { data } = JSON.parse(cachedData);
        currentWeather.value = data;
        weatherError.value = false;
      } else {
        ElMessage.error('获取天气数据失败: ' + (error.response?.data?.message || error.message));
      }
    } finally {
      weatherLoading.value = false;
    }
  };
  let weatherTimer = null;
  // 计算认识天数
  const startDate = new Date('2025-03-29'); // 设置你们认识的开始日期
  const today = new Date();
  const daysTogether = ref(Math.floor((today - startDate) / (1000 * 60 * 60 * 24)));
  
  const username = ref(localStorage.getItem('username') || '用户');
  const logout = async () => {
    try {
      // 如果有后端退出接口，可以调用
      // await axios.post('/api/auth/logout');
      
      // 清除本地存储的token和用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      
      // 跳转到登录页
      router.push({ name: 'login' });
      ElMessage.success('已退出登录');
    } catch (error) {
      console.error('退出登录失败:', error);
      ElMessage.error('退出登录失败');
    }
  };
  
  const router = useRouter();
  
  // 导航项配置
  
  
  const items = ref([]);
  const currentPage = ref(1);
  const pageSize = ref(3);
  const total = ref(0);
  const searchContent = ref('');
  const showModal = ref(false);
  const selectedRows = ref([]); 
  const form = ref({
    id: null,
    content: '',
    last: '',
    important: '',
  });
  
  // 导航跳转
  const navigateTo = (route) => {
    router.push(route);
  };
  
  // 获取数据
  const fetchItems = async () => {
    const response = await axios.get('/necessary/listByContent', {
      params: {
        page: currentPage.value,
        size: pageSize.value,
        content: searchContent.value,
      },
    });
    items.value = response.data.data.records;
    total.value = response.data.data.total;
    inputPage.value = currentPage.value.toString(); // 确保输入框显示当前页
  };
  
  // 搜索
  const search = () => {
    currentPage.value = 1;
    fetchItems();
  };
  // 处理选择事件
  const handleSelectionChange = (rows) => {
    selectedRows.value = rows;
  };
  // 添加
  const addItem = () => {
    form.value = {
      id: null,
      content: '',
      last: '',
      important: ''
    };
    showModal.value = true;
  };
  
  // 修改
  const editItem = (row) => {
    if (selectedRows.value.length === 1) {
      form.value = { ...selectedRows.value[0] };
      showModal.value = true;
    } else {
      ElMessage.warning('请选择一条记录');
    }
  };
  
  // 删除
  const deleteItem = async () => {
    if (selectedRows.value.length === 1) {
      const id = selectedRows.value[0].id;
      await axios.delete(`/necessary/delete/${id}`); 
      ElMessage.success('删除成功');
      fetchItems();
    } else {
      ElMessage.warning('请选择一条记录');
    }
  };
  
  // 保存
  const saveItem = async () => {
    try {
      const url = form.value.id ? '/necessary/edit' : '/necessary/save';
      const data = {
        ...form.value,
      };
      await axios.post(url, data);
      ElMessage.success(form.value.id ? '修改成功' : '添加成功');
      showModal.value = false;
      fetchItems();
    } catch (error) {
      console.error('保存失败:', error);
      ElMessage.error('保存失败');
    }
  };
  
  // 取消
  const cancel = () => {
    showModal.value = false;
  };
  
  
  
  // 点击表格行
  const handleRowClick = (row) => {
    form.value = { ...row };
  };
  
  onMounted(() => {
    fetchItems();
    fetchWeather();
    // 每2分钟刷新一次天气
    weatherTimer = setInterval(fetchWeather, CACHE_EXPIRY);
  });
  </script>
  
  <style scoped>
/* 表格内容样式 */
.table-content {
  font-size: 16px;  /* 增大字体大小 */
  font-weight: 500; /* 中等粗细 */
  color: #333;      /* 深灰色更易读 */
  padding: 8px 0;   /* 增加垂直内边距 */
  line-height: 1.5; /* 增加行高 */
}

.name-content {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #5a5a5a;   /* 深灰色 */
}


.wine-content {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #7a7a7a;   /* 稍浅的灰色 */
}

/* 状态标签样式 */
:deep(.el-tag) {
  font-size: 14px;
  padding: 0 10px;
  height: 28px;
  line-height: 28px;
  font-weight: 500;
}

/* 图片区域样式 */
.table-image-container {
  height: 120px;  /* 增加高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 表格行悬停效果 */
:deep(.el-table__row:hover) {
  background-color: #f8f9fa !important;
}

:deep(.el-table__row:hover .table-content) {
  color: #409eff; /* 悬停时变为主题蓝色 */
  transition: color 0.3s;
}

/* 无图片提示样式 */
.table-no-image {
  font-size: 14px;
  color: #909399;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.table-no-image .el-icon {
  font-size: 36px;  /* 增大图标 */
  margin-bottom: 8px;
  color: #c0c4cc;
}

/* 图片预览样式 */
.table-image {
  max-width: 150px;  /* 增大图片显示区域 */
  max-height: 120px;
  border-radius: 8px;
  transition: transform 0.3s;
}

.table-image:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}



  /* PDF管理区域样式 */
.pdf-management {
  margin: 20px 0;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.pdf-upload-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.upload-pdf-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.upload-pdf-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.upload-tip {
  margin-left: 20px;
  font-size: 14px;
  color: #909399;
}

.pdf-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pdf-list-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.pdf-name {
  display: flex;
  align-items: center;
  gap: 10px;
}

  /* 表格图片容器 */
  .table-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 110px;
    padding: 8px;
  }
  /* 表格中的图片样式 */
  .table-image {
    width: 100%;
    height: 100%;
    max-width: 130px;
    max-height: 110px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    object-fit: cover;
  }
  
  .table-image:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: zoom-in;
  }
  
  /* 表格中无图片的样式 */
  .table-no-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 14px;
    background-color: #fafafa;
    border-radius: 6px;
    border: 1px dashed #dcdfe6;
  }
  .table-no-image .el-icon {
    font-size: 30px;
    margin-bottom: 8px;
    color: #c0c4cc;
  } 
  .custom-dialog {
    border-radius: 12px;
  }
  
  .custom-dialog :deep(.el-dialog__header) {
    background: linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%);
    margin: 0;
    padding: 16px 20px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  
  .custom-dialog :deep(.el-dialog__title) {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
  .custom-dialog :deep(.el-dialog__body) {
    padding: 20px 30px;
    background-color: #fff;
  }
  
  /* 表单样式 */
  .custom-form {
    padding: 0  20px;
  }
  .confirm-button {
    background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
    border: none;
    border-radius: 8px;
    padding: 10px 25px;
    color: white;
    font-weight: 500;
    transition: all 0.3s;
    margin-left: 15px;
  }
  
  .confirm-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(161, 140, 209, 0.3);
  }
  .cancel-button {
    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
    border: none;
    border-radius: 8px;
    padding: 10px 25px;
    color: white;
    font-weight: 500;
    transition: all 0.3s;
  }
  
  .cancel-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(246, 211, 101, 0.3);
  }
  
  .no-image .el-icon {
    font-size: 40px;
    margin-bottom: 10px;
    color: #c0c4cc;
  }
  
  /* 底部按钮 */
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 15px 20px;
    background-color: #fff;
    border-top: 1px solid #eee;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
  .no-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    border: 1px dashed #dcdfe6;
    border-radius: 8px;
    color: #909399;
    font-size: 14px;
    background-color: #fafafa;
    margin-top: 15px;
  }
  
  
  /* 图片预览区域 */
  .image-preview {
    margin-top: 15px;
  }
  
  .preview-image {
    width: 200px;
    height: 200px;
    border-radius: 8px;
    border: 1px solid #eee;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
  }
  
  .preview-image:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  .upload-button {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    color: white;
    font-weight: 500;
    transition: all 0.3s;
    width: 120px;
  
  }
  
  .upload-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(79, 172, 254, 0.3);
  }
  /* 图片上传区域 */
  .image-item {
    margin-top: 30px;
  }
  
  .image-uploader {
    display: flex;
    flex-direction: column;
    gap: 300px; /* 增加上传按钮和图片预览之间的间距 */
    margin-left: 300px;
  }
  
  .custom-upload {
    margin-bottom: 0;
  }
  
  .form-item :deep(.el-form-item__label) {
    font-weight: 600;
    color: #5a5a5a;
    padding-right: 15px;
    line-height: 40px;
  }
  
  /* 状态选择器调整 */
  .status-item :deep(.el-select) {
    width: 100%;
  }
  
  .status-item :deep(.el-input__inner) {
    height: 40px;
    line-height: 40px;
  }
  .form-item {
    margin-bottom: 24px;
  }
  
  .pagination-container {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  
  .custom-pagination {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
  
  .page-input {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #606266;
  }
  
  .page-input .el-input {
    width: 60px;
  }
  
  .page-input .el-input__inner {
    text-align: center;
  }
  
  .total-pages {
    margin-left: 10px;
    color: #909399;
  }
  
  /* 按钮样式保持不变 */
  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 60px;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 40px;
  }
  
  .header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
  
  .center-title {
    font-size: 20px;
    font-weight: bold;
    color: pink;
  }
  
  .days-counter {
    font-size: 14px;
    color: #666;
  }
  
  .header-actions {
    display: flex;
    align-items: center;
  }
  
  .el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  .username {
    margin-left: 10px;
    font-size: 16px;
  }
  
  .home-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  /* 导航按钮组微调 */
  .nav-buttons {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  
  
  
  .home-button {
    background: linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%) !important;
  }
  .home-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 154, 158, 0.4);
  }
  .el-button-group {
    display: flex;
    gap: 15px;
  }
  
  /* 导航按钮样式 */
  .nav-button {
    font-weight: bold;
    padding: 12px 22px;
    border-radius: 8px;
    font-size: 16px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    border: none;
    color: #fff;
  }
  .nav-button:nth-child(1) {
    background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
    box-shadow: 0 4px 6px rgba(161, 140, 209, 0.3);
  }
  
  .nav-button:nth-child(2) {
    background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%);
    box-shadow: 0 4px 6px rgba(251, 194, 235, 0.3);
  }
  
  .nav-button:nth-child(3) {
    background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%);
    box-shadow: 0 4px 6px rgba(132, 250, 176, 0.3);
  }
  
  .nav-button:nth-child(4) {
    background: linear-gradient(135deg, #ffc3a0 0%, #ffafbd 100%);
    box-shadow: 0 4px 6px rgba(255, 195, 160, 0.3);}
  
  .nav-button:nth-child(5) {
    background: linear-gradient(135deg, #ffb347 0%, #ffcc33 100%);
    box-shadow: 0 4px 6px rgba(255, 179, 71, 0.3);
  }
  
  .nav-button:nth-child(6) {
    background: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
    box-shadow: 0 4px 6px rgba(71, 118, 230, 0.3);
  }
  .nav-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  .password-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  }
  .password-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);
  }
  
  /* 按钮悬停效果增强 */
  .home-button:hover,
  .nav-button:hover,
  .password-button:hover {
    filter: brightness(1.05);
  }
  /* 按钮激活效果 */
  .home-button:active,
  .nav-button:active,
  .password-button:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  
  .search-box {
    width: 60%;
    min-width: 500px;
    max-width: 700px;
  }
  .search-box-container {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
    width: 100%;
  }
  .search-input {
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .search-input :deep(.el-input__inner) {
    height: 40px;
    border-radius: 20px 0 0 20px;
    padding-left: 20px;
    font-size: 16px;
  }
  .search-button {
    height: 40px;
    border-radius: 0 20px 20px 0;
    background: linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%);
    color: white;
    border: none;
  }
  
  
  .restaurant-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  .action-buttons {
    margin-bottom: 20px;
  }
  
  .pagination {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  /* 图片预览样式 */
  .el-image {
    transition: transform 0.3s;
    cursor: pointer;
  }
  
  .el-image:hover {
    transform: scale(1.05);
  }
  
  /* 添加过渡动画 */
  :deep(.el-image-viewer__wrapper) {
    transition: opacity 0.3s;
  }
  .weather-info {
    display: flex;
    align-items: center;
    font-size: 17px; /* 增大字体 */
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; /* 更优雅的字体 */
    color: #5a5a5a; /* 更柔和的文字颜色 */
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* 微妙的文字阴影 */
  }
  
  
  .weather-item {
    display: inline-flex;
    align-items: center;
    margin: 0 10px;
    padding: 6px 12px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 8px rgba(22, 13, 128, 0.08);
    transition: all 0.3s ease;
  }
  
  .weather-item:hover {
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
  .weather-icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  }
  
  
  .days-counter {
    font-size: 17px;
    font-weight: 600;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    color: #ff6b9e; /* 更柔和的粉色 */
    margin-left: -30px; /* 再向左移动 */
    padding: 6px 14px;
    border-radius: 15px;
    background: linear-gradient(135deg, rgba(255, 182, 193, 0.2) 0%, rgba(255, 215, 0, 0.1) 100%);
    box-shadow: 0 3px 10px rgba(255, 107, 158, 0.2);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    margin-right: 100px;
  
  }
  .days-counter:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 14px rgba(255, 107, 158, 0.3);
  }
  .action-buttons {
    margin-bottom: 25px;
    display: flex;
    gap: 15px;
  }
  .action-buttons .el-button {
    font-weight: 600;
    font-size: 15px;
    padding: 12px 25px;
    border-radius: 8px;
    border: none;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  /* 添加按钮 */
  .action-buttons .el-button--primary {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  }
  
  /* 修改按钮 */
  .action-buttons .el-button--warning {
    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  }
  

/* PDF管理区域样式 */
.pdf-management {
  margin: 20px 0;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.pdf-upload-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.upload-pdf-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.upload-pdf-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.upload-tip {
  margin-left: 20px;
  font-size: 14px;
  color: #909399;
}

.pdf-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.pdf-list-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.pdf-name {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* PDF操作按钮样式 */
.pdf-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-right: 20px;
}
.preview-btn {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
  color: white;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  box-shadow: 0 2px 6px rgba(79, 172, 254, 0.3);
}
.preview-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 172, 254, 0.4);
}
.delete-btn {
  background: linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%);
  border: none;
  color: white;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  box-shadow: 0 2px 6px rgba(255, 117, 140, 0.3);
}
.delete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 117, 140, 0.4);
}

.action-btn {
  flex: 1;
  min-width: 70px;
  padding: 8px 10px;
  border-radius: 6px;
  transition: all 0.3s;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
/* PDF分页样式 */
.pdf-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

/* 调整表格列对齐 */
:deep(.el-table .el-table__cell) {
  text-align: center;
}

:deep(.el-table .el-table__cell.is-right) {
  text-align: right;
  padding-right: 20px;
}


.pdf-pagination .custom-pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 8px;
}
.pdf-pagination .page-info {
  font-size: 14px;
  color: #606266;
  padding: 0 15px;
}

.pdf-pagination .el-button {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  transition: all 0.3s;
}
.pdf-pagination .el-button:hover {
  background: #f5f7fa;
  color: #409eff;
  border-color: #c6e2ff;
}

.pdf-pagination .el-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


  /* 删除按钮 */
  .action-buttons .el-button--danger {
    background: linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%);
  }
  .action-buttons .el-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
    filter: brightness(1.05);
  }
  
  .action-buttons .el-button:active {
    transform: translateY(1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
  /* 按钮图标样式 */
  .action-buttons .el-button [class*="el-icon"] {
    margin-right: 8px;
    font-size: 16px;
  }
  .el-icon.is-loading {
    margin-right: 5px;
    animation: rotating 2s linear infinite;
  }
  .large-textarea {
  width: 100%;
  min-height: 200px;
  font-size: 16px;
  line-height: 1.6;
}
  
  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>